<template>
  <div>
    <!-- 订单统计 -->
    <h3>
      {{ $t('message.orderStatistics') }}
    </h3>
    <div class="orderStatistics">
      <!-- 订单数量 -->
      <div class="item">
        <div>
          {{ $t('message.orderQuantity') }}
          <div class="num">{{ orderStatistics.orderCount }}</div>
        </div>
      </div>
      <!--下单金额  -->
      <div class="item">
        <div>
          {{ $t('message.orderAmount') }}
          <div class="num">{{ orderStatistics.orderAmount }} ¥</div>
        </div>
      </div>
      <!-- 节省金额 -->
      <div class="item">
        <div>
          {{ $t('message.saveMoney') }}
          <div class="num">{{ orderStatistics.amountSaved }} ¥</div>
        </div>
      </div>
    </div>
    <!-- 订单统计 -->
    <h3>
      {{ $t('message.detail') }}
    </h3>
    <div class="table">
      <ol>
        <li class="flex05">NO</li>
        <!-- 订单号 -->
        <li> {{ $t('message.orderNumber') }}</li>
        <!-- 下单金额 -->
        <li> {{ $t('message.orderAmount') }}</li>
        <!-- 状态 -->
        <li> {{ $t('message.status') }}</li>
        <!-- 国内运费 -->
        <li> {{ $t('message.domesticFreight') }}</li>
        <!-- 国内运费比例 -->
        <li> {{ $t('message.domesticFreightRatio') }}</li>
        <!-- 附加服务费 -->
        <li> {{ $t('message.additionalServiceCharge') }}</li>
        <!-- 附加服务费比例 -->
        <li> {{ $t('message.additionalServiceFeeRatio') }}</li>
        <!-- 总金额 -->
        <li> {{ $t('message.totalKin') }}</li>
        <!-- 纳期 -->
        <li class="flex05"> {{ $t('message.deliveryTime') }}</li>
      </ol>
      <ul v-for="(item, index) in tableData" :key="index">
        <li class="flex05">{{ item.rowNumber }}</li>
        <!-- 订单号 -->
        <li>
          <router-link :to="'/orderDetail?order_sn=' + item.order_sn" class="a-link" target="_blank">
            {{ item.order_sn }}
          </router-link>
        </li>
        <!-- 下单金额 -->
        <li> {{ item.goods_amount }}</li>
        <!-- 状态 -->
        <li> {{ item.status }}</li>
        <!-- 国内运费 -->
        <li> {{ item.freight_amount }}</li>
        <!-- 国内运费比例 -->
        <li> {{ item.freight_ratio }}</li>
        <!-- 附加服务费 -->
        <li> {{ item.option_amount }}</li>
        <!-- 附加服务费比例 -->
        <li> {{ item.option_ratio }}</li>
        <!-- 总金额 -->
        <li> {{ item.total_amount }}</li>
        <!-- 纳期 -->
        <li class="flex05">

          <el-popover placement="left" title="纳期" trigger="click">
            <el-table :data="[item.order_time_node]" border>
              <el-table-column width="100" label="订单提交时间" align="center">
                <template slot-scope="scope">
                  {{ scope.row.submission_time ? scope.row.submission_time : '--' }}
                </template>
              </el-table-column>
              <el-table-column width="100" label="翻译" align="center">
                <template slot-scope="scope">
                  {{ scope.row.datetime_translate ? scope.row.datetime_translate : '--' }}
                </template>
              </el-table-column>
              <el-table-column width="100" label="调查" align="center">
                <template slot-scope="scope">
                  {{ scope.row.datetime_confirm ? scope.row.datetime_confirm : '--' }}
                </template>
              </el-table-column>
              <el-table-column width="100" label="报价" align="center">
                <template slot-scope="scope">
                  {{ scope.row.datetime_offer ? scope.row.datetime_offer : '--' }}
                </template>
              </el-table-column>
              <el-table-column width="100" label="客户入金" align="center">
                <template slot-scope="scope">
                  {{ scope.row.datetime_pay_submit ? scope.row.datetime_pay_submit : '--' }}
                </template>
              </el-table-column>
              <el-table-column width="100" label="财务确认入金" align="center">
                <template slot-scope="scope">
                  {{ scope.row.datetime_pay_confirm ? scope.row.datetime_pay_confirm : '--' }}
                </template>
              </el-table-column>
              <el-table-column width="100" label="采购" align="center">
                <template slot-scope="scope">
                  {{ scope.row.datetime_purchase_complete ? scope.row.datetime_purchase_complete : '--' }}
                </template>
              </el-table-column>
              <el-table-column width="100" label="财务付款(有问题)" align="center">
                <template slot-scope="scope">
                  {{ scope.row.submission_time ? scope.row.submission_time : '--' }}
                </template>
              </el-table-column>
              <el-table-column width="100" label="上架" align="center">
                <template slot-scope="scope">
                  {{ scope.row.datetime_up_complete ? scope.row.datetime_up_complete : '--' }}
                </template>
              </el-table-column>
            </el-table>
            <el-button type="text" slot="reference"> {{ $t('message.look') }}</el-button>
          </el-popover>
        </li>
      </ul>
    </div>
    <!-- 分页 -->
    <div class="paginationContainer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orderStatistics: {},
      user_id: this.$route.query.userID,
      datas: {
        page: 1,
        pageSize: 10,
        user_id: this.$route.query.userID,
      },
      total: 0,
      tableData: [],
    };
  },
  created() {
    this.userOrderStatistics()
    this.userOrderList()
  },
  methods: {
    userOrderStatistics() {
      this.$api.clienteleApi.userOrderStatistics({ user_id: this.user_id }).then((res) => {
        this.orderStatistics = res.data
      });
    },
    userOrderList() {
      this.$api.clienteleApi.userOrderList(this.datas).then((res) => {
        this.tableData = res.data.data
        this.total = res.data.total
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.userOrderList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.userOrderList();
    },
  }
}
</script>
<style lang='scss' scoped>
h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 24px;
}

.orderStatistics {
  display: flex;
  margin: 24px 0;

  .item {
    flex: 1;
    margin-right: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;
    background-color: #fff;
    text-align: center;
    font-size: 18px;
    border-radius: 5px;

    &:nth-last-child(1) {
      margin: 0;
    }

    .num {
      margin-top: 6px;
      color: #b4272d;
    }
  }
}

.table {
  .flex05 {
    flex: 0.5;
  }
}

.paginationContainer {
  text-align: center;
  padding: 24px 0;
}
</style>